import React from 'react';
import UnfulfilledWarehouseOrders from '../../../components/shared/UnfulfilledWarehouseOrders';
import { getCorpOrdersColumns } from '../../../components/shared/UnfulfilledWarehouseColumns';

const CorpUnfulfilledWarehouseOrdersPage = () => {
  return (
    <UnfulfilledWarehouseOrders
      apiEndpoint="/orders/corp/unfulfilled-warehouse"
      linkBasePath="/corp-orders"
      pageTitle="Corp Unfulfilled by Warehouse"
      breadcrumbTitle="Orders"
      getColumns={getCorpOrdersColumns}
      orderType="corp"
    />
  );
};

export default CorpUnfulfilledWarehouseOrdersPage; 
